<template>
    <div class="qi-modal-backdrop" @click.self="$emit('close')">
        <div class="qi-modal-card">
            <div class="qi-modal-header">
                <h6 class="mb-0">New Tax / Levy</h6>
                <button type="button" class="btn btn-sm btn-link text-muted p-0" @click="$emit('close')">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
            <form @submit.prevent="save">
                <div class="qi-modal-body">
                    <div class="form-group mb-2">
                        <label class="small mb-1">Tax name</label>
                        <input type="text" class="form-control" v-model="form.tax" required placeholder="e.g. VAT, Catering Levy">
                    </div>
                    <div class="form-group mb-2">
                        <label class="small mb-1">Rate (%)</label>
                        <input type="number" step="0.01" min="0" class="form-control" v-model.number="form.tax_perc" required>
                    </div>
                    <div class="form-group mb-2">
                        <label class="small mb-1">Description <span class="text-muted">(optional)</span></label>
                        <textarea class="form-control" v-model="form.description" rows="2"></textarea>
                    </div>
                    <div class="custom-control custom-checkbox mb-1">
                        <input type="checkbox" class="custom-control-input" id="tax-on-receipt" v-model="form.on_receipt">
                        <label class="custom-control-label small" for="tax-on-receipt">Show this tax on customer receipt</label>
                    </div>
                    <small class="text-muted d-block">It'll be enabled immediately and available to pick on any item.</small>

                    <div v-if="error" class="alert alert-danger py-2 px-3 mt-2 mb-0 small">{{ error }}</div>
                </div>
                <div class="qi-modal-footer">
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="$emit('close')">Cancel</button>
                    <button type="submit" class="btn btn-primary btn-sm" :disabled="!form.tax || !form.tax_perc || saving">
                        <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
                        Create tax
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { apiErrorMessage } from './docHelpers';

export default {
    name: 'TaxQuickAddModal',
    data() {
        return {
            saving: false,
            error: '',
            form: {
                tax: '',
                tax_perc: null,
                description: '',
                on_receipt: true,
            },
        };
    },
    methods: {
        async save() {
            this.saving = true;
            this.error = '';
            try {
                const { data } = await axios.post('/api/taxes', {
                    tax: this.form.tax,
                    tax_perc: this.form.tax_perc,
                    description: this.form.description,
                    on_receipt: !!this.form.on_receipt,
                    // Created inline from Invoices/Quotes/Inventory — usable
                    // right away, unlike the manual enable/disable toggle
                    // Settings keeps for taxes created there.
                    auto_enable: 1,
                });
                this.$toasts.push({ type: 'success', message: `"${data.tax}" created and ready to use.` });
                this.$emit('created', data);
            } catch (e) {
                this.error = apiErrorMessage(e, 'Could not create this tax. Please try again.');
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.small { margin: 0; }
.qi-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1080;
    background: rgba(0, 0, 0, .4);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}
.qi-modal-card {
    background: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 380px;
    box-shadow: 0 12px 40px rgba(0,0,0,.25);
    overflow: hidden;
}
.qi-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid #eee;
}
.qi-modal-body { padding: 16px; }
.qi-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #eee;
    background: #fafafa;
}
</style>
